import type { IntlShape } from 'react-intl-next';

export const confirmDiscardNotificationCommentDraft = (intl: IntlShape): boolean => {
	const confirmMessage = intl.formatMessage({
		id: 'app-navigation.notifications.unsaved-changes.confirm',
		defaultMessage: 'Do you want to discard this comment? Your comment will be lost if you do.',
	});
	return window.confirm(confirmMessage);
};

export const shouldSkipConfirmationForLinkClick = (
	event: Event | MouseEvent | KeyboardEvent | null,
): boolean => {
	// Check if the close event was triggered by a link click
	if (event && event.type === 'click') {
		const target = event.target as HTMLElement;
		const link = target.closest('a');
		if (link && link.href && !link.href.startsWith('javascript:')) {
			// If it's a link click, don't show confirmation - let Prompt handle it
			return true;
		}
	}

	return false;
};

export const handlePopupCloseWithUnsavedChanges = (
	event: Event | MouseEvent | KeyboardEvent | null,
	intl: IntlShape,
	onClose: () => void,
): void => {
	if (shouldSkipConfirmationForLinkClick(event)) {
		return;
	}

	if (event && event.type === 'keydown') {
		const keyboardEvent = event as KeyboardEvent;
		if (keyboardEvent.key === 'Escape' || keyboardEvent.key === 'Esc') {
			if (!confirmDiscardNotificationCommentDraft(intl)) {
				return;
			}
		}
	}

	onClose();
};
